<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">
					{{ patient.name }}
					<i class="icon-fav" @click="handleFav" v-if="patient.star == 1"></i>
					<i class="icon-fav-no" @click="handleFav" v-else></i>
					<el-tag type="danger" v-if="patient.inHospitalState" size="medium">{{ patient.inHospitalState
						}}</el-tag>
					<router-link target="_blank" :to="{ name: 'Contract/Common', query: { status: 1 } }">
						<el-tag type="info" size="medium" v-if="patient.signState == 0"
							@click="toContractPages(patient)">待签约</el-tag>
					</router-link>
					<router-link target="_blank" :to="{ name: 'Contract/Common', query: { status: 2 } }">
						<el-tag type="success" size="medium" v-if="patient.signState == 1"
							@click="toContractPages(patient)">已签约: 服务剩余 {{ patient.signServiceDay }} 天</el-tag>
					</router-link>
					<router-link target="_blank" :to="{ name: 'Contract/Common', query: { status: 3 } }">
						<el-tag type="warning" size="medium" v-if="patient.signState == 2"
							@click="toContractPages(patient)">待续签: 服务剩余 {{ patient.signServiceDay }} 天</el-tag>
					</router-link>
					<router-link target="_blank" :to="{ name: 'Contract/Common', query: { status: 4 } }">
						<el-tag type="info" size="medium" v-if="patient.signState == 3"
							@click="toContractPages(patient)">无意向</el-tag>
					</router-link>

				</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>患者管理</span>|
					<router-link class="active" :to="{ name: 'Patient/List' }">患者列表</router-link>|
					<span v-text="patient.name"></span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>
		<el-row :gutter="20">
			<el-col :span="6">

				<el-card class="user-info">
					<div slot="header" class="el-card-header">
						<span>患者信息</span>
						<el-link class="noline fc key  " @click="showDlg(7, patient)"><i class="icon-sync"></i>
							更新信息</el-link>
					</div>
					<div class="el-card-main">
						<div class="item infoitem">
							姓名:<b>{{ patient.name }}</b>
							性别:<b>{{ patient.sex == 1 ? '男' : '女' }}</b>
							年龄:<b>{{ patient.age }}岁</b>

						</div>

						<!-- <div class="item">{{patient.idcard}}  
							{{patient.nation}}
						</div> -->
						<div class="item ">默认电话：</div>

						<div class="item tell-item" style='margin-top:10px;' v-if="validRelatives.length > 0">
							<div class="tel-num">
								<b style="margin-right:8px;"> {{ (hospitalCode === 'FJ_SX1') &&
									relativeList['emr']?.length > 0 ? relativeList['emr'][0].phone :
									validRelatives[0].phone }}</b>
								<p style="margin-top:4px">
									<span style="color:#616161">{{ validRelatives[0].name }}</span>
									<i>{{ validRelatives[0].relationship ?
										phoneRelationship[validRelatives[0].relationship] : '(患者本人)' }}</i>
								</p>
							</div>

							<div class="alignCenter">
								<el-tooltip content="编辑" slot="reference" placement="top" :enterable="false">
									<el-link class="noline"><i @click="showDlg(1)" class="icon-edit"></i></el-link>
								</el-tooltip>
								<el-popconfirm hide-icon cancelButtonType='primary' confirmButtonText='呼叫+0'
									cancelButtonText='呼叫' title="拨号方式"
									@confirm="callHandle(validRelatives[0].phone, validRelatives[0], 'add')"
									@cancel="callHandle(validRelatives[0].phone, validRelatives[0])">
									<el-tooltip content="拨号" slot="reference" placement="top" :enterable="false">
										<i class="icon-tel"></i>
									</el-tooltip>
								</el-popconfirm>
								<el-tooltip content="短信" slot="reference" placement="top" :enterable="false">
									<el-link class="noline"><i class="icon-msg"
											@click="showDlg(5, validRelatives)"></i></el-link>
								</el-tooltip>
							</div>
						</div>

						<el-divider></el-divider>
						<div class="item">
							<div class="sub-title">疾病标签<div class="flr"><el-link class="fc key noline"
										@click="showDlg(3)"><i class="icon-edit"></i></el-link></div>
							</div>
							<div class="tag-group">
								<el-tag class="round" size="mini" type="danger" v-for="item in patient.diseaseTagList"
									:key="item.tagId">{{ item.tagName }}</el-tag>
							</div>
						</div>
						<el-divider></el-divider>
						<!-- <div class="item">
							<div class="sub-title">
								生活方式标签
								<div class="flr"><el-link class="fc key noline" @click="showDlg(4)"><i class="icon-edit"></i></el-link></div>
							</div>
							<div class="tag-group">
								<el-tag class="round" size="mini" type="danger" v-text="item.tagName" v-for="item in patient.lifeTagList" :key="item.tagId"></el-tag>
							</div>
						</div> -->
						<div class="item">
							<div class="sub-title">
								患者分组
							</div>
							<div class="tag-group">
								<router-link target="_blank"
									:to="{ name: 'Patient/GroupView', query: { groupingId: item.groupingId } }"
									v-for="item in patient.groupingList" :key="item.groupingId">
									<el-tag class="round" size="mini" type="success">{{ item.groupingName }}</el-tag>
								</router-link>
							</div>
						</div>
					</div>
				</el-card>

				<el-card class="phoneBookWrap">
					<div slot="header" class="el-card-header">
						<span>其他电话</span>
						<span style="color:#699CE4;cursor:pointer;" @click="showDlg(2)"><i class="el-icon-plus"
								style="margin-right:6px;"></i>添加电话</span>
					</div>
					<div class="phoneBook">
						<div class='emptyItem' v-if="relativeList.length == 0">
							暂无其他电话号码<br />
							点击下方按钮获取最新电话
						</div>
						<template v-if="relativeList.length != 0">

							<div class="phoneItem alignCenter" v-for="(item, index) in relativeList" :key="index">
								<div class="leftItem">
									<p>
										<b>{{ item.phone }}</b>
										<el-tag class="round" size="mini" effect="plain">{{
											dataSourceObj[item.dataSource] }}</el-tag>
									</p>
									<p>{{ item.name }}<span style="font-size:12px">{{
										phoneRelationship[item.relationship] }}</span></p>
									<p class="setDefault" @click="signHandle(item)">设为默认电话</p>
								</div>
								<div class="rigItem">
									<div>
										<el-popconfirm hide-icon cancelButtonType='primary' confirmButtonText='呼叫+0'
											cancelButtonText='呼叫' title="拨号方式"
											@confirm="callHandle(item.phone, item, 'add')"
											@cancel="callHandle(item.phone, item)">
											<el-tooltip content="拨号" slot="reference" placement="top"
												:enterable="false">
												<i class="icon-tel"></i>
											</el-tooltip>
										</el-popconfirm>
										<el-tooltip content="短信" slot="reference" placement="top" :enterable="false">
											<el-link class="noline"><i class="icon-msg"
													@click="showDlg(5, item)"></i></el-link>
										</el-tooltip>
									</div>
									<div>
										<el-tooltip content="编辑" slot="reference" placement="top" :enterable="false">
											<el-link class="noline"><i @click="showDlg(2, item)"
													class="icon-edit"></i></el-link>
										</el-tooltip>
										<el-popconfirm confirmButtonText='删除' title="确定删除吗？"
											@confirm="delRelative(item)">
											<el-tooltip content="删除" slot="reference" placement="top"
												:enterable="false">
												<el-link class="noline"><i class="el-icon-delete"
														style="font-size: 18px;"></i></el-link>
											</el-tooltip>
										</el-popconfirm>
									</div>
								</div>
							</div>
						</template>
						<div class="jocontCenter addNew" v-if="showGetNewPhone">
							<el-button type="primary" size="mini" @click="showDlg(8)">
								<svg-icon iconName="icon-a-zu1614" style="width:15.28px;height:15px"></svg-icon>
								获取最新电话
							</el-button>
						</div>
					</div>
				</el-card>

				<el-card class="user-eval" v-if="hospitalCode == 'BJ_FT1'">
					<div slot="header" class="el-card-header">
						<span>六方成评估</span>
					</div>
					<div class="el-card-main">
						<div class="item" v-for="(item, index) in getSideEvalList" :key="index">
							<div>
								<div class="eval-title">{{ item.evalName }}</div>

								<div v-if="item.finishTime" class="date">最近评估：{{ item.finishTime }}</div>
								<div v-else><el-link type="primary" :underline="false"
										@click="onEvalShow(item)">去评估</el-link></div>
								<!-- <div v-if="eval.customer[item.value]" class="date">最近评估：{{ eval.customer[item.value] }}</div>
								<div v-else><el-link type="primary" :underline="false" @click="onEvalShow(item)">去评估</el-link></div> -->

							</div>
							<div v-if="item.finishTime"><el-button type="text" @click="onEvalShow(item)"><i
										class="icon-research"></i></el-button></div>
						</div>


						<div class="item" v-if="getSideEvalList.length == 0">
							<div>
								<div class="eval-title">此患者没有身份证号码，无法进行评估，请先补充身份证号码</div>
								<div><router-link target="_blank" style="text-decoration: none;"
										:to="{ name: 'Patient/NoIdentity', query: { name: patient.name } }"><el-link
											type="primary" :underline="false">去补充</el-link></router-link></div>

								<!-- <div v-if="eval.customer[item.value]" class="date">最近评估：{{ eval.customer[item.value] }}</div>
								<div v-else><el-link type="primary" :underline="false" @click="onEvalShow(item)">去评估</el-link></div> -->

							</div>
						</div>

					</div>
				</el-card>
				<el-card class="user-manage-wrap">
					<div slot="header" class="el-card-header">
						<span>患者管理日志</span>
					</div>
					<div class="el-card-main">
						<UserManageLog :patientId="patient.id" />

					</div>
				</el-card>

				<!-- <el-card class="user-risk">
					<div slot="header" class="el-card-header">
						<span>疾病风险</span>
					</div>
					<div class="el-card-main">
						<div v-if="!patient.patientDiseaseRiskVOList || patient.patientDiseaseRiskVOList.length == 0">无</div>
						<template v-for="(item,idx) in patient.patientDiseaseRiskVOList">
						<div class="risk" :key="idx">
							<div class="sub-title">{{item.riskDegree}} <span v-text="item.riskType"></span></div>
							<el-progress :color="item.color" :show-text="false" :stroke-width="10" :percentage="item.value"></el-progress>							
						</div>
						<el-divider :key="idx" v-if="(idx+1) < patient.patientDiseaseRiskVOList.length"></el-divider>							
						</template>
					</div>
				</el-card> -->



			</el-col>
			<el-col :span="18">
				<el-tabs class="customize tab-divide" @tab-click="handleTab" v-model="currentTab">
					<el-tab-pane label="基本信息" name="t1" class="bg-w" :key="1" :lazy="true">
						<div class="bg-w">
							<el-form ref="form" class="user-form" :class="{ edit: isEditMode }" v-loading="isLoading">
								<el-row :gutter="20">
									<el-col :span="5">
										<label>姓名</label>
										<span class="f" v-text="form.name"></span>
										<input class="fe txtbox" type="text" v-model="formEdit.name" />
									</el-col>
									<el-col :span="5">
										<label>性别</label>
										<span class="f inpage">{{ form.sex == 1 ? '男' : '女' }}</span>
										<el-select class="fe customize" size="mini" v-model="formEdit.sex"
											placeholder="请选择" disabled>
											<el-option label="男" :value="1"></el-option>
											<el-option label="女" :value="2"></el-option>
										</el-select>
									</el-col>
									<el-col :span="5">
										<label>年龄</label>
										<span class="f inpage" v-text="form.age"></span>
										<input class="fe txtbox inpage" type="text" v-model="formEdit.age" disabled />
									</el-col>
									<el-col :span="9">
										<label>出生日期</label>
										<span class="f inpage" v-text="form.birthday"></span>
										<el-date-picker class="fe" size="mini" style="width:140px" type="date"
											placeholder="出生日期" :clearable="false" :editable="false"
											value-format="yyyy-MM-dd" v-model="formEdit.birthday"
											disabled></el-date-picker>
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<!-- <el-col :span="10">
										<label>身份证号</label>
										<span class="f" v-text="form.idcard"></span>
										<input class="fe txtbox" type="text" maxlength="18" v-model="formEdit.cardNum" />
									</el-col> -->
									<el-col :span="14">
										<label>本人电话</label>
										<span class="f" v-text="form.phone"></span>
										<input class="fe txtbox" type="text" maxlength="12" v-model="formEdit.phone" />
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<el-col :span="24">
										<label>家庭住址</label>
										<span class="f" v-text="form.companyAddress"></span>
										<input class="fe txtbox" type="text" maxlength="200"
											v-model="formEdit.companyAddress" />
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<el-col :span="10">
										<label>常住类型</label>
										<span class="f" v-text="form.residentType"></span>
										<input class="fe txtbox" type="text" maxlength="50"
											v-model="formEdit.residentType" />
									</el-col>
									<el-col :span="7">
										<label>民族</label>
										<span class="f" v-text="form.nation"></span>
										<el-select class="fe customize nation" size="mini" filterable
											v-model="formEdit.nation" placeholder="请选择">
											<el-option v-for="(item, index) in nationDatas" :label="item.label"
												:value="item.value" :key="index"></el-option>
										</el-select>

									</el-col>
									<el-col :span="7">
										<label>血型</label>
										<span class="f" v-text="form.blood"></span>
										<el-select class="fe customize" size="mini" v-model="formEdit.blood"
											placeholder="请选择">
											<el-option label="A" value="A"></el-option>
											<el-option label="B" value="B"></el-option>
											<el-option label="AB" value="AB"></el-option>
											<el-option label="O" value="O"></el-option>
											<el-option label="未查" value="未查"></el-option>
										</el-select>
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<el-col :span="10">
										<label>文化程度</label>
										<span class="f" v-text="form.educationDegree"></span>
										<input class="fe txtbox" type="text" maxlength="50"
											v-model="formEdit.educationDegree" />
									</el-col>
									<el-col :span="14">
										<label>职业</label>
										<span class="f" v-text="form.profession"></span>
										<input class="fe txtbox" type="text" v-model="formEdit.profession" />
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<el-col :span="10">
										<label>婚姻状况</label>
										<span class="f" v-if="form.marry == 2">已婚</span>
										<span class="f" v-if="form.marry == 1">未婚</span>
										<span class="f" v-if="form.marry == 0">未说明婚姻状况</span>
										<el-select class="fe customize" size="mini" v-model="formEdit.marry"
											placeholder="请选择">
											<el-option label="已婚" :value="2"></el-option>
											<el-option label="未婚" :value="1"></el-option>
											<el-option label="未知" :value="0"></el-option>
										</el-select>
									</el-col>
									<el-col :span="14">
										<label>医疗费用支付方式</label>
										<span class="f" v-text="form.costType" title="城镇职工基本医疗保险"></span>
										<input class="fe txtbox" type="text" maxlength="50"
											v-model="formEdit.costType" />
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<el-col :span="10">
										<label>药物过敏史</label>
										<span class="f" v-text="form.allergyHistory"></span>
										<input class="fe txtbox" type="text" v-model="formEdit.allergyHistory" />
									</el-col>
									<el-col :span="14">
										<label>既往史</label>
										<span class="f" v-text="form.pastHistory"></span>
										<input class="fe txtbox" type="text" v-model="formEdit.pastHistory" />
									</el-col>
								</el-row>
								<div class="action" v-if="!isEditMode"><el-button size="small" type="primary" plain
										round @click="handleEditMode">修改</el-button></div>
								<div class="action" v-else>
									<el-button size="small" type="primary" plain round
										@click="saveForm('basicInfo')">保存</el-button>
									<el-button size="small" plain round @click="handleEditMode">取消</el-button>
								</div>
							</el-form>
						</div>

					</el-tab-pane>

					<el-tab-pane label="管理日志" name="t2" class="bg-w" :key="2" :lazy="true">
						<TabLog :patientId="patient.id"></TabLog>
					</el-tab-pane>

					<el-tab-pane label="就诊记录" name="t3" :key="3" :lazy="true">
						<TabFollowUp :customerId="customerId" :patientId="patient.id" :onEvalShow="onEvalShow"
							:type="evalList.type" :patient="patient"></TabFollowUp>
					</el-tab-pane>
					<el-tab-pane label="体征记录" name="t4" class="bg-w" :key="4" :lazy="true">
						<TabBio :patientId="patient.id"></TabBio>
					</el-tab-pane>

					<el-tab-pane label="随访计划" name="t5" :key="5" :lazy="true" v-if="patient.id">
						<TabPlan ref="t5" :customerId="customerId" :patientId="patient.id" :onEvalShow="onEvalShow"
							:smsFlag="smsFlag" :smsPrice="smsPrice" :patient="patient">
						</TabPlan>
					</el-tab-pane>

					<el-tab-pane label="备忘录" name="t6" :key="6" class="bg-w" :lazy="true">
						<TabNote :patientId="patient.id"></TabNote>
					</el-tab-pane>

					<el-tab-pane label="沟通记录" name="t7" class="bg-w" :key="7" :lazy="true">
						<TabCommunication :patientId="patient.id"></TabCommunication>
					</el-tab-pane>
					<!-- 专项管理，等高血压评估出来再显示 -->
					<!-- <el-tab-pane label="专项管理" name="t8" class="bg-w" :key="8" :lazy="true">
						<TabSpecial :patientId="patient.id"></TabSpecial>
					</el-tab-pane> -->

				</el-tabs>
			</el-col>
		</el-row>


		<el-dialog custom-class="relative" title="患者信息" width="500px" :visible.sync="dlg.active"
			:close-on-click-modal="false">
			<el-form ref="form" size="small" label-width="60px" :rules="dlg.rules" :model="formEdit">
				<!-- <el-form-item label="姓名" prop="name">
					<el-input placeholder="请添加姓名" autocomplete="off" maxlength="10" :show-word-limit="true"
						v-model="formEdit.name"></el-input>
				</el-form-item> -->
				<el-form-item label="性别" prop="sex">
					<el-radio-group v-model="formEdit.sex" size="mini">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="电话" prop="phone">
					<el-input autocomplete="off" maxlength="12" :show-word-limit="true"
						v-model="formEdit.phone"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" size="mini" round :loading="isLoading"
					@click="saveForm('default')">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog custom-class="relative" :title="dlg.title2" width="400px" :visible.sync="dlg.active2"
			:close-on-click-modal="false">
			<el-form ref="form2" size="small" label-width="60px" :rules="dlg.rules2" :model="form2">
				<el-form-item label="姓名" prop="name">
					<el-input placeholder="请添加姓名" autocomplete="off" maxlength="10" :show-word-limit="true"
						v-model="form2.name"></el-input>
				</el-form-item>
				<el-form-item label="关系" prop="relationship">
					<el-select class="customize" size="mini" v-model="form2.relationship" placeholder="请选择">
						<el-option v-for="(item, index) in patientRelationship" :label="item.label" :value="item.value"
							:key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="电话" prop="phone">
					<el-input autocomplete="off" maxlength="20" :show-word-limit="true"
						v-model="form2.phone"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg(1)">取消</el-button>
				<el-button type="primary" size="mini" round :loading="isLoading" @click="saveForm2">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog custom-class="disease" title="疾病标签" width="500px" :visible.sync="dlg.active3"
			:close-on-click-modal="false">
			<el-form ref="form3" label-width="60px" :rules="dlg.rules3" :model="form3">
				<el-form-item label="已选">
					<div class="tag-group">
						<el-tag class="round" size="small" type="danger" closable @close="removeTag(1, item)"
							v-for="item in tag.added" :key="item.tagId">{{ item.tagName }}</el-tag>
					</div>
				</el-form-item>

				<el-form-item label="可选">
					<div class="tag-group">
						<template v-for="item in tag.source">
							<el-tag class="round" size="small" type="danger" @click="addTag(1, item)" :key="item.tagId"
								v-text="item.tagName" v-if="!item.hide"></el-tag>
						</template>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" size="mini" round :loading="isLoading" @click="saveForm3">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog custom-class="disease" title="生活方式标签" width="500px" :visible.sync="dlg.active4"
			:close-on-click-modal="false">
			<el-form ref="form4" label-width="60px" :rules="dlg.rules4" :model="form3">
				<el-form-item label="已选">
					<div class="tag-group">
						<el-tag class="round" size="small" type="danger" closable @close="removeTag(1, item)"
							v-for="item in tag.added" :key="item.tagId">{{ item.tagName }}</el-tag>
					</div>
				</el-form-item>

				<el-form-item label="可选">
					<div class="tag-group">
						<template v-for="item in tag.source">
							<el-tag class="round" size="small" type="danger" @click="addTag(1, item)" :key="item.tagId"
								v-text="item.tagName" v-if="!item.hide"></el-tag>
						</template>
					</div>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" size="mini" round :loading="isLoading" @click="saveForm4">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog title="发短信" label-position="left" width="645px" :visible.sync="dlg.active5"
			:close-on-click-modal="false" class="dialogForm5">
			<el-form ref="form5" :rules="dlg.rules5" :model="{ ...form5, templateForm }">
				<div class="form5Line">
					<el-form-item label="接收人:">
						<div class="to-users">{{ form5.users }}</div>
					</el-form-item>
					<el-form-item label="接收电话:">
						<div class="to-users">{{ form5.phone }}</div>
					</el-form-item>
				</div>
				<el-form-item label="短信模版名称" class="form5Line2" prop="smsTemplateCode">
					<el-select size="mini" v-model="form5.code" :value-key="'id'" placeholder="请选择"
						@change="handleChange($event, form5.smsTemplateCode)">
						<el-option v-for="(item, index) in templateList" :label="item.templateName" :value="item.id"
							:key='index'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="短信内容" prop="content" class='form5Textarea' v-if='form5.smsTemplateCode'>
					<div class="sms-content">
						<span v-for="(part, index) in parsedParts" :key="index">
							<!-- 普通文字 -->
							<template v-if="part.type === 'text'">
								{{ part.value }}
							</template>
							<span v-else-if="part.key === 'name'">{{ templateForm[part.key] }}</span>
							<!-- 占位符字段 -->
							<template v-else>
								<el-form-item :prop="`templateForm.${part.key}`" class='partFormCon'>
									<el-input v-if="fieldMap[part.key] === 'input'" v-model="templateForm[part.key]"
										style="width: 132px;" placeholder="请输入" />
									<el-date-picker
										v-if="fieldMap[part.key] === 'date' || fieldMap[part.key] === 'days'"
										v-model="templateForm[part.key]" type="date" placeholder="选择日期"
										style="width: 132px;" value-format="yyyy-MM-dd" :clearable="false" />
									<el-select size="mini" v-model="templateForm[part.key]" placeholder="请选择"
										v-if="fieldMap[part.key] === 'select' && part.key != 'doctor'">
										<el-option label="血压" value="血压" style='width:132px'></el-option>
										<el-option label="血糖" value="血糖" style='width:132px'></el-option>
										<el-option label="血压及血糖" value="血压及血糖" style='width:132px'></el-option>
									</el-select>

									<el-select size="mini" v-model="templateForm[part.key]" placeholder="请选择"
										v-if="part.key === 'doctor'">
										<el-option v-for="(item, index) in mainList" :label="item.name" :value="item.name"
											:key=index style='width:132px'></el-option>
									</el-select>
								</el-form-item>
							</template>
						</span>
					</div>
					<div v-if="smsFlag">
						计费说明：当前{{ form5.content.length }}/{{ smsPrice }}字，预计&nbsp;{{ Math.ceil(form5.content.length /
						smsPrice)
						}}条短信，以实际发送为准
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg(1)">取 消</el-button>
				<el-button type="primary" @click="saveForm5" v-if="!isLoading">发 送</el-button>
				<el-button type="primary" :loading="true" v-else>发送中</el-button>
			</div>
		</el-dialog>

		<!-- <el-dialog title="签约" width="560px" center :visible.sync="dlg.active6" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="签约周期：" prop="period">
					<el-date-picker type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy/MM/dd" v-model="form.period"></el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm6">保存</el-button>
			</div>
		</el-dialog> -->

		<el-dialog custom-class="callerDlg" title="患者信息" width="700px" center :visible.sync="dlg.active7"
			:close-on-click-modal="false">
			<div>
				<p>请选择要同步的患者信息来源</p>
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="patientInfoList" v-loading="isLoading">
					<el-table-column prop="datasources" label="数据来源" width="100"></el-table-column>
					<el-table-column prop="patientHisId" label="p-his-id" width="100"></el-table-column>
					<el-table-column prop="returnResult" label="查询结果">
						<template slot-scope="scope">
							<div v-text="scope.row" class="botwrap"></div>
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="80">
						<template slot-scope="scope">
							<el-popconfirm confirmButtonText='确定' title="确定同步吗？" @confirm="syncPatientInfo(scope.row)">
								<el-tooltip class="fc key" style="cursor:pointer" content="同步" slot="reference"
									placement="top" :enterable="false"><i class="icon-sync"></i></el-tooltip>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog custom-class="callerDlg" title="最新电话" width="700px" center :visible.sync="dlg.active8"
			:close-on-click-modal="false">
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
				:data="phoneList" v-loading="isLoading" class="dialogTable">
				<el-table-column label="来源" width="80">
					<template slot-scope="scope">
						{{ dataSourceObj[scope.row.dataSource] }}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="姓名" width="80"></el-table-column>
				<el-table-column prop="phone" label="电话"></el-table-column>
				<el-table-column prop="relativesName" label="患者亲属" width="80"></el-table-column>
				<el-table-column label="关系">
					<template slot-scope="scope">
						{{ phoneRelationship[scope.row.relativesRelationship] }}
					</template>
				</el-table-column>
				<el-table-column prop="relativesPhone" label="亲属电话"></el-table-column>

				<el-table-column fixed="right" label="操作" width="80">
					<template slot-scope="scope">
						<el-tooltip class="fc key" style="cursor:pointer" content="添加" slot="reference" placement="top"
							:enterable="false">
							<i class="el-icon-circle-plus-outline" @click="addPhone(scope.row)"></i>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">关闭</el-button>
			</div>
		</el-dialog>


		<EvalList :type="evalList.type" :name="evalList.name" :patientId="patientId" :customerId="customerId"
			:visible.sync="evalList.active" />

	</div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';

import TabLog from './components/user-log.vue';
import TabBio from './components/user-bio.vue';
import TabFollowUp from './components/user-followup.vue';
import TabPlan from './components/user-plan.vue';
import TabNote from './components/user-note.vue';
import TabCommunication from './components/user-communication.vue';
// import TabSpecial from './components/special/index.vue';//隐藏专项管理
import EvalList from './components/special/components/eval-list.vue';
import UserManageLog from './components/user-manage-log.vue'

import store from '../../store';
import telMixins from '../../layout/components/Navbar/telMixins';


import {
	MessageBox
} from 'element-ui'
import {
	EventBus
} from '@/event-bus.js';
import nationData from './data.json'
export default {
	components: {
		TabLog,
		TabBio,
		TabFollowUp,
		TabPlan,
		TabNote,
		TabCommunication,
		EvalList,
		UserManageLog
	},
	mixins: [mixin, telMixins], //telMixins
	watch: {
		$route() {
			let query = this.$route.query;
			if (query && query.t) {
				this.currentTab = `t${query.t}`;
			}
		},
		templateForm: {
			handler(newVal) {
				this.form5.content = this.template.replace(/\$\{(.*?)\}/g, (match, key) => {
					if (key === 'name') {
						return this.form5.users; // name字段使用用户名
					}
					return this.templateForm[key] || '';
				});
			},
			deep: true
		},
	},
	computed: {
		getSideEvalList: function () {
			return this.$store.state.eval.sideList;
		},
	},
	data() {
		var validatePhone = (rule, value, callback) => {
			if (!/^\d{7,19}$/.test(value)) {
				callback(new Error('电话号码无效'));
			} else {
				callback();
			}
		};
		return {
			dlg: {
				// 患者信息
				active: false,
				// 患者关系
				active2: false,
				// 疾病标签
				active3: false,
				// 生活方式标签
				active4: false,
				// 发短信
				active5: false,
				// 无身份证号码
				active6: false,
				// 更新患者信息
				active7: false,
				// 最新电话
				active8: false,
				title2: '',
				rules: {
					name: {
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					},
					sex: {
						required: true,
						message: '请选择性别',
						trigger: 'blur'
					},
					phone: [{
						required: true,
						message: '请输入电话'
					}, {
						validator: validatePhone,
						trigger: 'blur'
					}]
				},
				rules2: {
					name: {
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					},
					relationship: {
						required: true,
						message: '请选择关系'
					},
					phone: [{
						required: true,
						message: '请输入电话'
					}, {
						validator: validatePhone,
						trigger: 'blur'
					}]
				},
				rules5: {
					smsTemplateCode: {
						required: true,
						message: '请选择短信模板',
						trigger: ['change', 'blur']

					}
				}
			},
			isEvalListActive: false,
			isEditMode: false,
			currentTab: 't1',
			patientId: 0,
			customerId: 0,
			tag: {
				added: [],
				source: []
			},
			evalList: {
				active: false,
				type: 0,
			},
			form: {},
			formEdit: {
				relationship: '',
				phone: '',
				sex: null
			},
			form2: {
				patientId: 0,
				name: '',
				relationship: '',
				phone: ''
			},
			form3: {
				patientId: 0,
				diseaseTagIdList: [],
				lifeTagIdList: []
			},
			// 短信表单
			form5: {
				users: '',
				content: '',
				shortMessageSendListPos: [],
				smsTemplateCode: '',
				code: ''
			},
			patient: {}, // 患者信息
			relativeList: [], // 家属信息
			tagDisease: [], // 患者标签
			tagLife: [], // 患者标签
			// special: { s1: undefined, s2: undefined, s3: undefined, s4: undefined, s5: undefined },
			eval: {
				typeList: undefined,
				customer: [],
			},
			smsPrice: 50,
			smsFlag: false,
			GXcallFlag: false,
			UboxCallFlag: false,
			patientInfoList: [],
			permission: false,
			nationDatas: [],
			validRelatives: [],
			showGetNewPhone: false,
			phoneList: [],
			templateList: [],//短信模版列表
			template: "复诊提醒：${name}您好，请您于${date}前往${dept}复诊。就诊时${remark}在医院现场挂号就诊。",//模版内容
			fieldMap: {
				name: 'input',
				date: 'date',
				days: 'date',
				remark: 'input',
				dept: 'input',
				types: 'select',
				doctor: 'select',
				phone: 'input'
			},
			templateForm: {
				name: '',
				date: '',
				remark: '',
				dept: '',
				days: '',
				types: '',
				doctor: '',
				phone: ''
			},
			parsedParts: [],
			mainList: []
		}
	},
	async created() {
		this.init();
		this.smsFlag = await api.getSmsFlag();
		this.GXcallFlag = await api.getGXcallFlag();
		this.UboxCallFlag = await api.getUboxCallFlag();
		this.showGetNewPhone = await api.getShowGetNewPhone()
		// this.callInit();
		this.nationDatas = nationData;
	},
	mounted() {
		this.getQueryTemplateList()
	},
	methods: {
		handleChange(event, code) {
			let obj = this.templateList.find(item => item.id == event)
			this.template = obj.templateContent;
			this.form5.smsTemplateCode = obj.templateCode;
			// 1. 重置验证规则，只保留模板选择的规则
			this.dlg.rules5 = {
				smsTemplateCode: {
					required: true,
					message: '请选择短信模板',
					trigger: ['change', 'blur']
				}
			};

			// 2. 清空动态表单字段和内容
			this.templateForm = {};
			this.templateForm.name = this.form5.users;
			this.form5.content = '';
			console.log(this.template, '==========template', this.templateForm)
			// 3. 解析新模板并生成规则
			this.parsedParts = this.parseTemplate(this.template);
			this.generateDynamicRules();

			// 4. 清空表单验证状态
			this.$nextTick(() => {
				if (this.$refs['form5']) {
					this.$refs['form5'].clearValidate();
				}
			});

		},
		parseTemplate(str) {
			const regex = /\$\{(.*?)\}/g;
			let match;
			let lastIndex = 0;
			const result = [];

			while ((match = regex.exec(str)) !== null) {
				// 添加前面的文字
				if (match.index > lastIndex) {
					result.push({
						type: 'text',
						value: str.slice(lastIndex, match.index)
					});
				}

				// 添加变量
				result.push({
					type: 'field',
					key: match[1]
				});

				lastIndex = regex.lastIndex;
			}

			// 添加剩下的文字
			if (lastIndex < str.length) {
				result.push({
					type: 'text',
					value: str.slice(lastIndex)
				});
			}
			console.log(result, '==========result')
			return result;
		},
		async init() {
			// this.isEvalListActive = true;
			// this.isRelativeFormActive = true;
			// 切换到指定tab页
			let query = this.$route.query;
			if (query && query.t) {
				this.currentTab = `t${query.t}`;
			}
			this.patientId = +query.patientId;

			this.getPatient()
			this.loadTag();



			// 六方成评估 - 用户数据
			// this.loadAllEval();
			// 更新信息 权限
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = this.user.user.roleId == "1" ? true : false;

			api.getComboboxUserList({ roleId: 2 }).then((res) => {
				if (res.code == 1000 && res.data) {
					this.mainList = res.data;
				}
			})
		},
		async getPatient() {
			let loading = this.$loading({
				lock: true,
				text: 'Loading'
			});
			let res = await api.getPatient({
				patientId: this.patientId
			});
			loading.close();
			if (res.code == 500) {
				return this.$router.push({
					name: 'Login',
					query: {
						r: location.href
					}
				});
			}
			res.data.mobile = res.data.phone;
			res.data.idcard = utils.hideIdCard(res.data.cardNum);
			res.data.diseaseTagList = res.data.diseaseTagList || [];
			res.data.lifeTagList = res.data.lifeTagList || [];
			res.data.patientDiseaseRiskVOList = res.data.patientDiseaseRiskVOList || [];
			this.patient = res.data;
			this.customerId = this.patient.customerId;
			// if (!this.customerId) {
			// 	this.dlg.active6 = true;
			// } else {
			// 	this.dlg.active6 = false;
			// }

			//修改页面title
			let title = {};
			title.name = res.data.name;
			title.sex = res.data.sex == 1 ? '男' : '女';
			title.age = res.data.age + '岁';
			document.title = title.name + ' ' + title.sex + ' ' + title.age;

			this.form = JSON.parse(JSON.stringify(res.data));
			this.loadRelative();
			// 六方成评估 - 所有评估类型(左侧边栏)
			this.loadEvalType();
		},
		loadRelative() {
			api.getRelativeList({
				patientId: this.patientId
			}).then((res) => {
				if (res.code == 1000 && res.data) {
					this.relativeList = res.data.otherRelatives;
					if (res.data.validRelatives?.length > 0) {
						this.validRelatives = res.data.validRelatives;
					} else {
						let obj = this.patient
						this.validRelatives = [obj];
						this.validRelatives[0].dataType = null;
					}

				}
			});
		},
		async addPhone(item) {
			item.patientId = this.patient.id;
			this.isLoading = true;
			let res = await api.getSyncData({ dataType: 6, operateType: 2, ...item.inputParams });
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message.success('添加成功');
			this.loadRelative();
			// this.closeDlg()
		},
		// 标记
		async signHandle(item) {
			let res;
			if (this.isLoading) {
				return;
			}

			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.insertValid({
					id: item.id,
				});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({
				message: '设置成功',
				type: 'success'
			});
			this.loadRelative();
		},
		// 相对应签约页面跳转
		toContractPages(item) {

			switch (item.signState) {
				case 0:
					localStorage.setItem('name', item.name);
					localStorage.setItem('cardNum', item.cardNum);
					break;
				case 1:
					localStorage.setItem('sigendName', item.name);
					localStorage.setItem('signedCardNum', item.cardNum);
					break;
				case 2:
					localStorage.setItem('reName', item.name);
					localStorage.setItem('reCardNum', item.cardNum);
					break;
				case 3:
					localStorage.setItem('noName', item.name);
					localStorage.setItem('noCardNum', item.cardNum);

					break;
			}
		},
		// 侧边 六方成评估
		async loadEvalType() {
			this.$store.commit('setCustomerId', this.customerId);
			await this.$store.dispatch('loadSideEvalList');
		},
		loadTag() {
			// 所有标签数据
			api.getPatientFilterTag({
				patientId: this.patientId
			}).then((res) => {
				if (res.code == 1000 && res.data) {
					this.tagDisease = res.data.diseaseTagList;
					this.tagLife = res.data.lifeTagList;
				}
			});
		},
		addTag(v, item) {
			this.tag.added.push(item);
			this.tag.source[this.tag.source.findIndex(ele => ele.tagId == item.tagId)].hide = true;
		},
		removeTag(v, item) {
			this.tag.source[this.tag.source.findIndex(ele => ele.tagId == item.tagId)].hide = false;
			this.tag.added.splice(this.tag.added.findIndex(ele => ele.tagId == item.tagId), 1);
		},
		showDlg(v, item) {
			let source;
			switch (v) {
				case 1: //本人
					this.dlg.active = true;
					// this.formEdit = JSON.parse(JSON.stringify(this.form));
					if ((this.hospitalCode === 'FJ_SX1') && this.relativeList['emr']?.length > 0) {
						this.formEdit.phone = this.relativeList['emr'][0].phone;

					} else {
						this.formEdit.phone = this.validRelatives[0].phone
					}
					this.formEdit.sex = JSON.parse(JSON.stringify(this.form)).sex;
					this.formEdit.id = this.validRelatives[0].id;
					this.formEdit.dataType = this.validRelatives[0].dataType;

					break;
				case 2: // 亲属
					this.dlg.active2 = true;
					this.$nextTick(() => {
						this.$refs['form2'].resetFields();
						console.log(item, '=======333334');
						if (item) {
							this.form2.id = item.id;
							this.form2.name = item.name;
							this.form2.relationship = item.relationship; TabLog
							this.form2.phone = item.phone;
							this.form2.dataType = item.dataType;

							this.dlg.title2 = '修改电话'
						} else {
							this.form2.id = 0;
							this.dlg.title2 = '新增电话'

						}
					});
					break;
				case 3: // 疾病标签
					this.dlg.active3 = true;
					this.tag.added = JSON.parse(JSON.stringify(this.patient.diseaseTagList));
					source = JSON.parse(JSON.stringify(this.tagDisease));
					this.tag.added.forEach((item) => {
						// source.splice(this.tag.added.findIndex(ele => ele.tagId == item.tagId), 1);
						source[this.tag.added.findIndex(ele => ele.tagId == item.tagId)].hide = true;
					});
					this.tag.source = source;
					break;
				case 4: // 生活标签
					this.dlg.active4 = true;
					this.tag.added = JSON.parse(JSON.stringify(this.patient.lifeTagList));
					source = JSON.parse(JSON.stringify(this.tagLife));
					this.tag.added.forEach((item) => {
						source[this.tag.added.findIndex(ele => ele.tagId == item.tagId)].hide = true;
					});
					this.tag.source = source;
					break;
				case 5:
					this.form5.content = '';
					this.form5.smsTemplateCode = '';
					this.form5.code = ''
					this.form5.shortMessageSendListPos = [{
						patientId: item.patientId ? item.patientId : item.id,
						phone: item.phone
					}];
					if (Array.isArray(item)) {
						this.form5.users = item[0].name;
						this.form5.phone = item[0].phone;
						this.form5.shortMessageSendListPos = [{
							patientId: item[0].patientId ? item[0].patientId : item[0].id,
							phone: item[0].phone
						}];
					} else {
						this.form5.users = item.name;
						this.form5.phone = item.phone;
						this.form5.shortMessageSendListPos = [{
							patientId: item.patientId ? item.patientId : item.id,
							phone: item.phone
						}];
					}
					this.dlg.active5 = true;
					this.$nextTick(() => {
						this.$refs['form5'].resetFields();
					});
					if (this.smsFlag) {
						this.smsPrice = this.hospitalCode == 'HE_QA1' ? 70 : 50;
					}
					break;
				case 6:
					this.dlg.active6 = true;
					this.$nextTick(() => {
						this.$refs['form6'].resetFields();
						this.form6.patientId = this.patientId;
					});
					break;
				case 7:// 同步患者信息
					this.patientInfoList = [];// 重置数据
					this.dlg.active7 = true;
					this.$nextTick(() => {
						this.syncPatient()
					});
					break;
				case 8:
					api.getSyncData({ dataType: 6, operateType: 1, patientId: this.patientId }).then(res => {
						if (res.code == 1000) {
							this.phoneList = res.data.flatMap(item => {
								const parsed = JSON.parse(item.returnResult);
								return parsed.map(r => ({
									...r,
									inputParams: JSON.parse(item.inputParams)
								}));
							});
						}
					})

					this.dlg.active8 = true;
			}
		},
		closeDlg() {
			this.dlg.active = false;
			this.dlg.active2 = false;
			this.dlg.active3 = false;
			this.dlg.active4 = false;
			this.dlg.active5 = false;
			this.dlg.active6 = false;
			this.dlg.active7 = false;
			this.dlg.active8 = false;
		},
		async getQueryTemplateList() {
			let res = await api.queryTemplateList({ templateType: 1 })
			if (res.code == 1000) {
				this.templateList = res.data
			}
		},
		// 其他弹窗 “确定” 处理
		onConfirm(v) {
			switch (v) {
				case 6:
					break;
			}
		},
		// 保存患者信息
		// 0812 新增判断手机号开头可以加0
		// 0820 修改为判断7位或12位的数字，兼容固话（本地不能加区号）。问题是短信没法发。
		// 6.9 修改电话接口改边
		async saveForm(type) {
			if (this.formEdit.phone != '' && !/^(\d{6}|\d{7}|\d{12}|\d{11})$/.test(this.formEdit.phone)) {
				return this.$message.warning('电话号码无效');
			}

			this.isLoading = true;
			let res;
			if (type == 'default') {
				res = await api.editRelative(this.formEdit);
			} else if (type == 'basicInfo') {
				res = await api.editPatient(this.formEdit);
			}
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.form = this.formEdit;
			this.form.idcard = utils.hideIdCard(this.form.cardNum);
			this.getPatient()
			this.closeDlg();
			this.isEditMode = false;
		},
		// 患者亲属
		saveForm2() {
			let res;
			this.$refs['form2'].validate(async (valid) => {
				if (valid) {
					this.isLoading = true;
					this.form2.patientId = this.patient.id;
					if (this.form2.id > 0) {
						res = await api.editRelative(this.form2);
					} else {
						res = await api.addRelative(this.form2);
					}
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.loadRelative();
					this.closeDlg();
				}
			});
		},
		// 疾病标签
		async saveForm3() {
			this.form3.patientId = this.patient.id;
			this.form3.diseaseTagIdList = this.tag.added.map((item) => {
				return item.tagId;
			});
			this.form3.lifeTagIdList = this.patient.lifeTagList.map((item) => {
				return item.tagId;
			});
			this.isLoading = true;
			let res = await api.updatePatientTag(this.form3);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.patient.diseaseTagList = this.tag.added;
			this.closeDlg();
		},
		// 生活标签
		async saveForm4() {
			this.form3.patientId = this.patient.id;
			this.form3.diseaseTagIdList = this.patient.diseaseTagList.map((item) => {
				return item.tagId;
			});
			this.form3.lifeTagIdList = this.tag.added.map((item) => {
				return item.tagId;
			});

			this.isLoading = true;
			let res = await api.updatePatientTag(this.form3);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('保存成功');
			this.patient.lifeTagList = this.tag.added;
			this.closeDlg();
		},
		generateDynamicRules() {
			// 遍历占位符生成 rules
			this.parsedParts.forEach(part => {
				if (part.type === 'field' && part.key !== 'name') {
					// name字段不需要用户输入，跳过验证规则生成
					// 初始化表单字段值
					this.$set(this.templateForm, part.key, '');

					// 根据字段类型设置不同的验证触发器
					let trigger = 'blur';
					let message = '请输入内容';
					let type

					if (this.fieldMap[part.key] === 'date' || this.fieldMap[part.key] === 'days') {
						trigger = ['change', 'blur'];
						message = '请选择日期';
					} else if (this.fieldMap[part.key] === 'select') {
						trigger = ['change', 'blur'];
						message = '请选择';
					}

					// 设置验证规则，使用正确的路径
					this.$set(this.dlg.rules5, `templateForm.${part.key}`, {
						required: true,
						message: message,
						trigger: trigger,
						type: type
					});

					if (part.key === 'phone') {
						trigger = ['blur', 'change'];
						message = '请输入正确的手机号';
						this.$set(this.dlg.rules5, `templateForm.${part.key}`, [{
							required: true,
							message: '请输入手机号',
							trigger: trigger
						}, {
							pattern: /^1[3-9]\d{9}$/,
							message: '请输入正确的手机号',
							trigger: trigger
						}]);
					}
				}
			});
		},
		async saveForm5() {
			// 先拼接最终内容，特殊处理name字段
			this.form5.content = this.template.replace(/\$\{(.*?)\}/g, (match, key) => {
				if (key === 'name') {
					return this.form5.users; // name字段使用用户名
				}
				return this.templateForm[key] || '';
			});
			this.form5.smsTemplateParam = JSON.stringify({ ...this.templateForm })
			console.log("拼接结果:", this.form5, this.templateForm, 'this.form5.content');

			// 表单验证
			this.$refs['form5'].validate(async (valid) => {
				if (valid) {
					this.isLoading = true;
					let res = await api.sendSMS(this.form5);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('短信发送成功');
					this.closeDlg();
				}
			});
		},
		async saveForm6() {

			this.$refs['form6'].validate(async (valid) => {
				if (valid) {
					this.isLoading = true;
					let res = await api.sendSMS(this.form5);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('短信发送成功');
					this.closeDlg();
				}
			})
		},
		/** 重点关注 **/
		async handleFav() {
			if (this.isLoading) {
				return;
			}
			this.patient.star = +!this.patient.star;
			this.isLoading = true;
			let res = await api.addPatientToStar({
				star: this.patient.star,
				patientIds: this.patient.id
			});
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
		},
		getTime(type) {
			const now = new Date();

			const year = now.getFullYear(); // 获取当前年份
			const month = String(now.getMonth() + 1).padStart(2, "0"); // 获取当前月份（注意要加 1）
			const date = String(now.getDate()).padStart(2, "0"); // 获取当前日期
			const hour = String(now.getHours()).padStart(2, "0"); // 获取当前小时数
			const minute = String(now.getMinutes()).padStart(2, "0"); // 获取当前分钟数
			const second = String(now.getSeconds()).padStart(2, "0"); // 获取当前秒数
			let time = `${year}${month}${date}${hour}${minute}${second}`;
			return time;
		},

		/** 打电话 **/
		async callHandle(phone, item, type) {
			if (type == 'add') {
				phone = '0' + phone
			}
			console.log(phone, '==========phone');
			if (!item.phone) {
				this.$message.error('电话为空,不可呼出!')
				return false;
			}
			this.isLoading = true;
			let res = await api.makePhoneCall(phone);
			if (this.hospitalCode == 'AH_FY1' || this.hospitalCode == 'YS_HM4') {
				let t1 = this.getTime()
				let fileName = phone + "-" + t1;
				window.info = {
					patientId: this.patient.id,
					phone: phone,
					relationship: item?.relationship ? item.relationship : 0,
				}
				this.addCallRecordEvt(fileName)
				console.log(fileName, '============fileName', window.info)
				return;

			}
			if (res == "copyMobile") {
				this.copyMobile(phone);
				this.isLoading = false;
				return;
			}

			if (this.GXcallFlag) {
				this.isLoading = false;
				let callState = localStorage.getItem('callState');
				let info = {
					patientId: item.patientId ? item.patientId : item.id,
					relationship: item?.relationship ? item.relationship : 0
				}
				if (callState) {
					// this.$message.error('请在结束通话后再拨打！')
					MessageBox.confirm('上次电话未正常结束，是否确认结束', '系统提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							localStorage.removeItem('callerInfo');
							localStorage.removeItem('tips');
							localStorage.removeItem('callState');
							localStorage.removeItem('phoneRecordId');
							localStorage.removeItem('callstatus');
							localStorage.removeItem('route');
							EventBus.$emit('update-callstatus', 'normal');
							setTimeout(() => {
								this.$message.success('结束成功,请重新拨打')
							}, 300);
							// this.makeCall(phone,info);								
						})
						.catch(() => { })
				} else {

					// let relationship=item?.relationship?item.relationship:0
					this.makeCall(phone, info);
				}
				// this.$message.success('电话呼出成功');
			} else if (this.UboxCallFlag) {
				// this.makeCall(8058,'015950647684');
				let info = {
					patientId: item.patientId ? item.patientId : item.id,
					relationship: item?.relationship ? item.relationship : 0
				}
				this.isLoading = false;
				let callState = localStorage.getItem('callState');
				console.log(info, '-----22');
				if (callState) {
					MessageBox.confirm('上次电话未正常结束，是否确认拨打', '系统提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							localStorage.removeItem('callerInfo');
							localStorage.removeItem('tips');
							localStorage.removeItem('callState');
							localStorage.removeItem('phoneRecordId');
							localStorage.removeItem('callstatus');
							localStorage.removeItem('route');
							EventBus.$emit('update-callstatus', 'normal');

							let h = localStorage.getItem('hdl')
							console.log(window.hdl, '======hdl', h);
							window.ubox_StopRecord(h);
							setTimeout(() => {
								this.$message.success('结束成功,请重新拨打')
							}, 300);
							// setTimeout(() => {
							// 	if(this.hospitalCode=='HE_QA1'){
							// 		let phonenum=`0${phone}`
							// 		this.makeCall(phonenum,info);
							// 	}else {
							// 		console.log(3333333);
							// 		this.makeCall(phone,info);
							// 	}
							// }, 300);
						})
						.catch(() => { })
				} else {
					if (this.hospitalCode == 'HE_QA1') {
						let phonenum = `0,${phone}`
						this.makeCall(phonenum, info);
					} else {
						this.makeCall(phone, info);
					}
				}
				// this.makeCall('015950647684');
				// this.$message.success('电话呼出成功');
			}
			// else if(!res){
			// 	this.isLoading = false;
			// 	this.$message.error('电话呼出失败');
			// }
		},
		copyMobile(phone) {
			this.$clipboard(phone);
			this.$message.success('手机号码复制成功');
		},
		// 删除患者亲属
		async delRelative(item) {
			let res;
			if (this.isLoading) {
				return;
			}

			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delRelative({
					patientRelativeId: item.id
				});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({
				message: '已删除',
				type: 'success'
			});
			this.loadRelative();
		},
		handleTab(tab) {
			switch (tab.name) {
				case 't1':
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 1
						}
					});
					break;
				case 't2':
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 2
						}
					});
					break;
				case 't3':
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 3
						}
					});
					break;
				case 't4':
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 4
						}
					});
					break;
				case 't5':
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 5
						}
					});
					break;
				case 't6':
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 6
						}
					});
					break;
				case 't7':
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 7
						}
					});
					break;
				case 't8':
					this.$router.push({
						name: 'Patient/User',
						query: {
							patientId: this.patientId,
							t: 8
						}
					});
					break;
			}
			// this.isEditMode = true;
		},
		handleEditMode() {
			this.formEdit = JSON.parse(JSON.stringify(this.form));
			this.isEditMode = !this.isEditMode;
		},
		onEvalShow(item) {
			console.log('内容', item);
			this.evalList.type = +item.type || +item.evalTypeId;
			this.evalList.name = item.evalName;
			this.evalList.active = true;
		},
		async syncPatient() {
			this.isLoading = true;
			let res = await api.getSyncData({
				dataType: 1,
				operateType: 1,
				patientId: this.patientId,
			})
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			console.log(res.data)

			res.data.forEach((item) => {
				let patientInfo = {
					datasources: '',
					returnResult: '',
					patientHisId: '',
					inputParams: ''
				}
				let inputParams = JSON.parse(item.inputParams)
				patientInfo.datasources = inputParams.datasources == '1' ? '门诊档案' : '住院档案';
				patientInfo.returnResult = item.returnResult;
				patientInfo.patientHisId = inputParams.patientHisId;
				patientInfo.inputParams = inputParams;

				this.patientInfoList.push(patientInfo)
			})
			this.isLoading = false;

		},
		async syncPatientInfo(v) {
			v.inputParams.dataType = 1;
			v.inputParams.operateType = 2;
			let res = await api.getSyncData(v.inputParams);
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.$message.success('同步成功');
			this.closeDlg();
		},

	},

}
</script>

<style lang="less">
@import './user.less';

// }
.botwrap {
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	height: 100px;
	overflow-y: auto;
}

.inpage {
	color: #ccc;
	background-color: transparent;
}

.el-input.is-disabled .el-input__inner {
	background-color: transparent;
}
</style>